import isEmpty from 'lodash/isEmpty';

import {TemplateRCDataFromRequest, LanguageData} from 'core/RateConfirmation/types';

export const isTranslatePL = (data: TemplateRCDataFromRequest): boolean => !isEmpty(data?.translation?.pl);
export const isRegionNA = (data: TemplateRCDataFromRequest): boolean => data?.region === 'na';

export const getTranslateSomeTitle = ({
    data,
    translateTitle,
}: {
    data: TemplateRCDataFromRequest;
    translateTitle: keyof LanguageData;
}) => {
    return data.translation ? data.translation.pl[translateTitle] : translateTitle;
};
